var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// /Users/dnnoyes/release-repo/~/isarray/index.js
// module id = 17
// module chunks = 0